import * as React from "react";
import { PureComponent } from "react";
import "./style.scss";
import { getDetailsIconProps, getVisibilityIconProps } from "./functions";
import Glyphicon from "../Glyphicon";
import AppContext from "../../context/AppContext";
import OpisWyjazdu from "../OpisWyjazdu";

class Wyjazd extends PureComponent<any, any> {
  static contextType = AppContext;

  constructor(props: any) {
    super(props);

    this.state = {
      isExpanded: false
    };
  }

  toggleDetails = () => {
    this.setState({ isExpanded: !this.state.isExpanded });
  };

  handleClick = () => {
    const { toggleTripSelection } = this.context;
    const { trip } = this.props;
    toggleTripSelection(trip.id);
  };

  render() {
    const { trip } = this.props;
    const visibilityIconProps = getVisibilityIconProps(trip);
    const detailsIconProps = getDetailsIconProps(this.state.isExpanded);
    return (
      <div className="Wyjazd">
        <button className="Wyjazd_button" onClick={this.handleClick}>
          <Glyphicon {...visibilityIconProps} />
          {trip.name}
        </button>
        <button className="Wyjazd_button" onClick={this.toggleDetails}>
          <Glyphicon {...detailsIconProps} />
        </button>
        {this.state.isExpanded && <OpisWyjazdu trip={trip} />}
      </div>
    );
  }
}

export default Wyjazd;
